/*
 * shopit-api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.41
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The Leaflet model module.
 * @module model/Leaflet
 * @version v1
 */
export class Leaflet {
  /**
   * Constructs a new <code>Leaflet</code>.
   * @alias module:model/Leaflet
   * @class
   * @param id {String} 
   * @param name {String} 
   * @param url {String} 
   * @param start_at {String} 
   * @param end_at {String} 
   */
  constructor(id, name, url, start_at, end_at) {
    this.id = id;
    this.name = name;
    this.url = url;
    this.start_at = start_at;
    this.end_at = end_at;
  }

  /**
   * Constructs a <code>Leaflet</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Leaflet} obj Optional instance to populate.
   * @return {module:model/Leaflet} The populated <code>Leaflet</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Leaflet();
      if (data.hasOwnProperty('id'))
        obj.id = ApiClient.convertToType(data['id'], 'String');
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('url'))
        obj.url = ApiClient.convertToType(data['url'], 'String');
      if (data.hasOwnProperty('supplier_id'))
        obj.supplier_id = ApiClient.convertToType(data['supplier_id'], 'String');
      if (data.hasOwnProperty('start_at'))
        obj.start_at = ApiClient.convertToType(data['start_at'], 'String');
      if (data.hasOwnProperty('end_at'))
        obj.end_at = ApiClient.convertToType(data['end_at'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} id
 */
Leaflet.prototype.id = undefined;

/**
 * @member {String} name
 */
Leaflet.prototype.name = undefined;

/**
 * @member {String} url
 */
Leaflet.prototype.url = undefined;

/**
 * @member {String} supplier_id
 */
Leaflet.prototype.supplier_id = undefined;

/**
 * @member {String} start_at
 */
Leaflet.prototype.start_at = undefined;

/**
 * @member {String} end_at
 */
Leaflet.prototype.end_at = undefined;

